export default __webpack_public_path__ + "static/media/keyboard.be7548b8.svg";